// extracted by mini-css-extract-plugin
module.exports = {"notification-bell":"NotificationBell_notification-bell__22PUd","svg-logo":"NotificationBell_svg-logo__3DzCF","badge":"NotificationBell_badge__aJZw2"};